import BaseService from './base.service';

export default class DeviceService {
    static ENDPOINT = '/devices';

    static async getDevices(params = {}) {
        return BaseService.get(this.ENDPOINT, params);
    }

    static async getDevice(id) {
        return BaseService.get(`${this.ENDPOINT}/${id}`);
    }

    static async getDevicesCount(orgId) {
        return BaseService.get(`${this.ENDPOINT}/count`, { orgId });
    }

    static async getOrgDevices(orgId, params = {}) {
        return BaseService.get(`/orgs/${orgId}/devices`, params);
    }

    static async getOrgDevicesCount(orgId) {
        return BaseService.get(`/orgs/${orgId}/devices/count`);
    }

    static async addDevice(devicesData) {
        const endpoint = `${this.ENDPOINT}`;
        return BaseService.post(endpoint, devicesData);
    }

    static async editDevice(id, devicesData) {
        const endpoint = `${this.ENDPOINT}/${id}`;
        return BaseService.patch(endpoint, devicesData);
    }

    // LPR devices carry no access groups, device number, or facility code, so they skip the CA4K
    // badge sync entirely and go through their own endpoint. The record still lands in `devices`.
    static async addLprDevice(deviceData) {
        const endpoint = `${this.ENDPOINT}/lpr`;
        return BaseService.post(endpoint, deviceData);
    }

    static async editLprDevice(id, deviceData) {
        const endpoint = `${this.ENDPOINT}/lpr/${id}`;
        return BaseService.patch(endpoint, deviceData);
    }

    static async deleteDevice(deviceId) {
        const endpoint = `${this.ENDPOINT}/${deviceId}`;
        return BaseService.delete(endpoint, {});
    }
}
